import { render, staticRenderFns } from "./BnInputField.vue?vue&type=template&id=19ded994&scoped=true&"
import script from "./BnInputField.vue?vue&type=script&lang=js&"
export * from "./BnInputField.vue?vue&type=script&lang=js&"
import style0 from "./BnInputField.vue?vue&type=style&index=0&id=19ded994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ded994",
  null
  
)

export default component.exports